import FilterBarFunctional from 'components/Pages/PressReleases/FilterBarFunctional';
import { ComponentProps } from 'lib/component-props';
import searchEntityTypes from 'constants/searchEntityTypes';

const PressReleaseFilterBar = ({ fields, rendering }: ComponentProps) => {
  const filterMappings = fields.filterMappings.value;
  const hasFilters = filterMappings.filters?.length;

  if (!hasFilters) return null;

  return (
    <FilterBarFunctional
      e2eID={rendering.uid}
      formattedMapping={filterMappings}
      entityTypes={searchEntityTypes.PRESS_RELEASE_TYPE}
    />
  );
};

export default PressReleaseFilterBar;
